import { FilterCondition } from '@common/interfaces';
import { GetOrderResponseData, Bound, Type1, Traveler, TravelerNamesInner } from 'src/sdk-servicing';

/**
 *
 * @param pnrInfo: pnr data from API.
 * @param conditions: list of condition that is used to filter flights (must be matched format {key, value, operator}).
 * @returns flights that meet all conditions.
 * @example filterFlightsByCondition(_pnr.model?.data, [{ key: 'statusCode', value: 1, operator: notEqual }, { key: 'isUpgraded', value: false, operator: equal }])
 */
export const filterFlightsByCondition = (pnrInfo?: GetOrderResponseData, conditions?: FilterCondition[]): Type1[] => {
  let flights: Type1[] = [];

  // Get all flights in pnr data.
  flights = pnrInfo?.air?.bounds?.flatMap((bound) => bound.flights ?? ([] as Type1[])) ?? ([] as Type1[]);

  // Filter flight by condition list.
  conditions?.forEach((condition: FilterCondition) => {
    flights = condition.operator(flights, condition.key, condition.value);
  });
  return flights;
};

/**
 *
 * @param pnrInfo: pnr data from API.
 * @param conditions: list of condition that is used to filter travelers (must be matched format {key, value, operator}).
 * @returns travelers that meet all conditions.
 * @example filterTravelersByCondition(_pnr.model?.data, [{ key: 'statusCode', value: 1, operator: notEqual }, { key: 'isUpgraded', value: false, operator: equal }])
 */
export const filterTravelersByCondition = (
  pnrInfo?: GetOrderResponseData,
  conditions?: FilterCondition[]
): Traveler[] => {
  let travelers: Traveler[] = [];

  // Get all travelers in pnr data.
  travelers = pnrInfo?.travelers ?? [];

  // Filter flight by condition list.
  conditions?.forEach((condition: FilterCondition) => {
    travelers = condition.operator(travelers, condition.key, condition.value);
  });
  return travelers;
};

/**
 * Concat items in travelerNames
 * @param texts travelerNames with value object
 * @returns text include "title firstName middleName lastName"
 */
export function concatenateTravelerNames(texts: TravelerNamesInner = {}): string {
  return Object.values(texts)
    .filter((value) => value !== undefined && value.trim() !== '')
    .join(' ');
}
